import { render, staticRenderFns } from "./FarmAdd.vue?vue&type=template&id=24ff3cf6&"
import script from "./FarmAdd.vue?vue&type=script&lang=js&"
export * from "./FarmAdd.vue?vue&type=script&lang=js&"
import style0 from "./FarmAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports